import { Component, PropType } from 'vue';
import { BrowseLikedComponent } from '@/scripts/Components/mixins/browseLikedComponent';
import { PageType } from './vs-browse';
import { Model } from '@viddsee/server-api-client';
import { browseApi } from '@/scripts/webcall/v3/browse';

interface ComponentData {
  hasErrorLoading: boolean;
  isLoading: boolean;
  videos: Model.Video.Info[];
}

export default {
  init(): Component {
    return BrowseLikedComponent.extend({
      props: {
        name: {
          type: String,
          required: true,
        },
        type: {
          type: String as PropType<PageType>,
          required: true,
        },
      },
      data(): ComponentData {
        return {
          hasErrorLoading: false,
          isLoading: false,
          videos: [],
        };
      },
      mounted() {
        (this as any).loadMoreVideos();
      },
      methods: {
        async loadVideos(): Promise<Model.Pagination.PaginatedItemsResponse<Model.Video.Info>> {
          const { data } = await browseApi.listPopular(undefined, {
            page: 0,
            perPage: 12,
          });

          return data;
        },
      },
    });
  },
};
